import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
// import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

const errorHandler = function (errorMsg, url, lineNumber) {
  window.console.log('errorhandler', typeof errorMsg, errorMsg)
  if (typeof errorMsg === 'object') {
    url = errorMsg.filename
    lineNumber = errorMsg.lineNumber ? errorMsg.lineNumber + ':' + errorMsg.columnNumber : errorMsg.lineno
    errorMsg = errorMsg.message
  }
  if (window.logEvent) {
    window.logEvent('error', errorMsg + ' ' + url + ':' + lineNumber)
    window.console.error(errorMsg + ' ' + url + ':' + lineNumber)
  }
  return false
}

window.addEventListener('error', errorHandler)
Vue.config.errorHandler = function (err, vm, info) {
  errorHandler(err + '(' + info + ')', '', 0)
}

new Vue({
  router,
  store,
  // vuetify,
  render: h => h(App)
}).$mount('#ge_game')
